import { render, staticRenderFns } from "./SocialMediaPage.vue?vue&type=template&id=ee12a490&"
import script from "./SocialMediaPage.vue?vue&type=script&lang=js&"
export * from "./SocialMediaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports